import React, { createContext, useState, ReactNode } from "react";

interface TotalHitsContextProps {
    totalHits: number;
    setTotalHits: (hits: number) => void;
}

export const TotalHitsContext = createContext<TotalHitsContextProps | undefined>(undefined);

export const TotalHitsProvider = ({ children }: { children: ReactNode }) => {
    const [totalHits, setTotalHits] = useState(0);

    return (
        <TotalHitsContext.Provider value={{ totalHits, setTotalHits }}>
            {children}
        </TotalHitsContext.Provider>
    );
};